import type { RespondMerchantConfirmationResponse } from '../model';

export class WrongAnswerConfirmationError extends Error {
  name = 'WRONG_ANSWER_CONFIRMATION_ERROR' as const;

  constructor(message: string) {
    super(message);
  }
}

export class ConfirmationFailedError extends Error {
  name = 'CONFIRMATION_FAILED_ERROR' as const;

  constructor(message: string) {
    super(message);
  }
}

export class UnexpectedConfirmationStatusError extends Error {
  name = 'UNEXPECTED_CONFIRMATION_STATUS_ERROR' as const;

  constructor(message: string) {
    super(message);
  }
}

export function isWrongAnswerConfirmationError(
  error: Error
): error is WrongAnswerConfirmationError {
  return error.name === 'WRONG_ANSWER_CONFIRMATION_ERROR';
}

export function isConfirmationFailedError(
  error: Error
): error is ConfirmationFailedError {
  return error.name === 'CONFIRMATION_FAILED_ERROR';
}

export function assertConfirmOrderSuccess(
  response: RespondMerchantConfirmationResponse
): RespondMerchantConfirmationResponse {
  switch (response.status) {
    case 'SUCCESS':
      return response;
    case 'WRONG_ANSWER':
      throw new WrongAnswerConfirmationError(response.reason);
    case 'NEXT':
    case 'FAILED':
      throw new ConfirmationFailedError(response.reason);
    default:
      throw new UnexpectedConfirmationStatusError(
        `Unexpected confirmation status: ${response.status}`
      );
  }
}
